import {
  DISPLAY_DEFAULT_REPORTS,
  DISPLAY_DEFAULT_REPORTS_FAILED,
  DISPLAY_DEFAULT_REPORTS_SUCCESS,
  GET_ACTIVE_SITE_USERS,
  GET_ACTIVE_SITE_USERS_FAILED,
  GET_ACTIVE_SITE_USERS_SUCCESS,
  GET_ACTIVE_USERS_REPORTS,
  GET_ACTIVE_USERS_REPORTS_FAILED,
  GET_ACTIVE_USERS_REPORTS_SUCCESS,
  GET_AD_REPORTS,
  GET_AD_REPORTS_FAILED,
  GET_AD_REPORTS_SUCCESS,
  GET_ALL_FEATURE_REPORTS,
  GET_ALL_FEATURE_REPORTS_FAILED,
  GET_ALL_FEATURE_REPORTS_SUCCESS,
  GET_ALL_USER_RESPONSES,
  GET_ALL_USER_RESPONSES_FAILED,
  GET_ALL_USER_RESPONSES_SUCCESS,
  GET_APP_OPENS_MONTH_REPORT,
  GET_APP_OPENS_MONTH_REPORT_FAILED,
  GET_APP_OPENS_MONTH_REPORT_SUCCESS,
  GET_APP_OPENS_REPORTS,
  GET_APP_OPENS_REPORTS_FAILED,
  GET_APP_OPENS_REPORTS_SUCCESS,
  GET_BOOKING_PAYMENT_REPORTS,
  GET_BOOKING_PAYMENT_REPORTS_FAILED,
  GET_BOOKING_PAYMENT_REPORTS_SUCCESS,
  GET_DASHBOARD_SECTIONS,
  GET_DASHBOARD_SECTIONS_FAILED,
  GET_DASHBOARD_SECTIONS_SUCCESS,
  GET_FEATURE_CLICKS,
  GET_FEATURE_CLICKS_FAILED,
  GET_FEATURE_CLICKS_SUCCESS,
  GET_FEATURE_RESPONSES_BY_USER,
  GET_FEATURE_RESPONSES_BY_USER_FAILED,
  GET_FEATURE_RESPONSES_BY_USER_SUCCESS,
  GET_FEATURE_USAGE_REPORT,
  GET_FEATURE_USAGE_REPORT_FAILED,
  GET_FEATURE_USAGE_REPORT_SUCCESS,
  GET_FEATURE_VIEWS_BY_USER,
  GET_FEATURE_VIEWS_BY_USER_FAILED,
  GET_FEATURE_VIEWS_BY_USER_SUCCESS,
  GET_FORM_BUILDER_PAYMENT_REPORTS,
  GET_FORM_BUILDER_PAYMENT_REPORTS_FAILED,
  GET_FORM_BUILDER_PAYMENT_REPORTS_SUCCESS,
  GET_FORM_LIST,
  GET_FORM_LIST_FAILED,
  GET_FORM_LIST_SUCCESS,
  GET_NEW_USERS_REPORTS,
  GET_NEW_USERS_REPORTS_FAILED,
  GET_NEW_USERS_REPORTS_SUCCESS,
  GET_RECENT_EXPERIENCES,
  GET_RECENT_EXPERIENCES_FAILED,
  GET_RECENT_EXPERIENCES_SUCCESS,
  GET_USER_REPORTS,
  GET_USER_REPORTS_FAILED,
  GET_USER_REPORTS_SUCCESS,
  RESET_ALL_USER_RESPONSES,
  RESET_APP_OPENS_REPORTS,
  RESET_FEATURE_CLICKS,
  RESET_FEATURE_RESPONSES_BY_USER,
  RESET_FEATURE_USAGE_REPORT,
  RESET_FEATURE_VIEWS_BY_USER,
  UPDATE_DASHBOARD_SECTIONS,
  UPDATE_DASHBOARD_SECTIONS_FAILED,
  UPDATE_DASHBOARD_SECTIONS_SUCCESS,
} from "./actionTypes"

export const getUserReports = params => ({
  type: GET_USER_REPORTS,
  payload: params,
})

export const getUserReportsSuccess = response => ({
  type: GET_USER_REPORTS_SUCCESS,
  payload: response,
})

export const getUserReportsFailed = error => ({
  type: GET_USER_REPORTS_FAILED,
  payload: error,
})

export const getActiveUsersReports = params => ({
  type: GET_ACTIVE_USERS_REPORTS,
  payload: params,
})

export const getActiveUsersReportsSuccess = response => ({
  type: GET_ACTIVE_USERS_REPORTS_SUCCESS,
  payload: response,
})

export const getActiveUsersReportsFailed = error => ({
  type: GET_ACTIVE_USERS_REPORTS_FAILED,
  payload: error,
})

export const getNewUsersReports = params => ({
  type: GET_NEW_USERS_REPORTS,
  payload: params,
})

export const getNewUsersReportsSuccess = response => ({
  type: GET_NEW_USERS_REPORTS_SUCCESS,
  payload: response,
})

export const getNewUsersReportsFailed = error => ({
  type: GET_NEW_USERS_REPORTS_FAILED,
  payload: error,
})

export const getRecentExperiences = params => ({
  type: GET_RECENT_EXPERIENCES,
  payload: params,
})

export const getRecentExperiencesSuccess = response => ({
  type: GET_RECENT_EXPERIENCES_SUCCESS,
  payload: response,
})

export const getRecentExperiencesFailed = error => ({
  type: GET_RECENT_EXPERIENCES_FAILED,
  payload: error,
})

export const getAdReports = params => ({
  type: GET_AD_REPORTS,
  payload: params,
})

export const getAdReportsSuccess = response => ({
  type: GET_AD_REPORTS_SUCCESS,
  payload: response,
})

export const getAdReportsFailed = error => ({
  type: GET_AD_REPORTS_FAILED,
  payload: error,
})

export const getBookingPaymentReports = params => ({
  type: GET_BOOKING_PAYMENT_REPORTS,
  payload: params,
})

export const getBookingPaymentReportsSuccess = response => ({
  type: GET_BOOKING_PAYMENT_REPORTS_SUCCESS,
  payload: response,
})

export const getBookingPaymentReportsFailed = error => ({
  type: GET_BOOKING_PAYMENT_REPORTS_FAILED,
  payload: error,
})

export const getDashboardSections = params => ({
  type: GET_DASHBOARD_SECTIONS,
  payload: params,
})

export const getDashboardSectionsSuccess = response => ({
  type: GET_DASHBOARD_SECTIONS_SUCCESS,
  payload: response,
})

export const getDashboardSectionsFailed = error => ({
  type: GET_DASHBOARD_SECTIONS_FAILED,
  payload: error,
})

export const updateDashboardSections = params => ({
  type: UPDATE_DASHBOARD_SECTIONS,
  payload: params,
})

export const updateDashboardSectionsSuccess = response => ({
  type: UPDATE_DASHBOARD_SECTIONS_SUCCESS,
  payload: response,
})

export const updateDashboardSectionsFailed = error => ({
  type: UPDATE_DASHBOARD_SECTIONS_FAILED,
  payload: error,
})

export const getFeatureResponsesByUser = params => ({
  type: GET_FEATURE_RESPONSES_BY_USER,
  payload: params,
})

export const getFeatureResponsesByUserSuccess = response => ({
  type: GET_FEATURE_RESPONSES_BY_USER_SUCCESS,
  payload: response,
})

export const getFeatureResponsesByUserFailed = error => ({
  type: GET_FEATURE_RESPONSES_BY_USER_FAILED,
  payload: error,
})

export const resetFeatureResponsesByUser = () => ({
  type: RESET_FEATURE_RESPONSES_BY_USER,
  payload: {},
})

export const getAllUserResponses = params => ({
  type: GET_ALL_USER_RESPONSES,
  payload: params,
})

export const getAllUserResponsesSuccess = response => ({
  type: GET_ALL_USER_RESPONSES_SUCCESS,
  payload: response,
})

export const getAllUserResponsesFailed = error => ({
  type: GET_ALL_USER_RESPONSES_FAILED,
  payload: error,
})

export const resetAllUserResponses = () => ({
  type: RESET_ALL_USER_RESPONSES,
  payload: {},
})

export const getFeatureUsageReport = params => ({
  type: GET_FEATURE_USAGE_REPORT,
  payload: params,
})

export const getFeatureUsageReportSuccess = response => ({
  type: GET_FEATURE_USAGE_REPORT_SUCCESS,
  payload: response,
})

export const getFeatureUsageReportFailed = error => ({
  type: GET_FEATURE_USAGE_REPORT_FAILED,
  payload: error,
})

export const resetFeatureUsageReport = () => ({
  type: RESET_FEATURE_USAGE_REPORT,
  payload: {},
})

export const getAppOpensReports = params => ({
  type: GET_APP_OPENS_REPORTS,
  payload: params,
})

export const getAppOpensReportsFailed = error => ({
  type: GET_APP_OPENS_REPORTS_FAILED,
  payload: error,
})

export const getAppOpensReportsSuccess = response => ({
  type: GET_APP_OPENS_REPORTS_SUCCESS,
  payload: response,
})

export const resetAppOpensReports = () => ({
  type: RESET_APP_OPENS_REPORTS,
  payload: {},
})

export const getAppOpensMonthReport = params => ({
  type: GET_APP_OPENS_MONTH_REPORT,
  payload: params,
})

export const getAppOpensMonthReportSuccess = response => ({
  type: GET_APP_OPENS_MONTH_REPORT_SUCCESS,
  payload: response,
})

export const getAppOpensMonthReportFailed = error => ({
  type: GET_APP_OPENS_MONTH_REPORT_FAILED,
  payload: error,
})

export const getActiveSiteUsers = params => ({
  type: GET_ACTIVE_SITE_USERS,
  payload: params,
})

export const getActiveSiteUsersSuccess = response => ({
  type: GET_ACTIVE_SITE_USERS_SUCCESS,
  payload: response,
})

export const getActiveSiteUsersFailed = error => ({
  type: GET_ACTIVE_SITE_USERS_FAILED,
  payload: error,
})

export const getFormBuilderPaymentReports = params => ({
  type: GET_FORM_BUILDER_PAYMENT_REPORTS,
  payload: params,
})

export const getFormBuilderPaymentReportsSuccess = response => ({
  type: GET_FORM_BUILDER_PAYMENT_REPORTS_SUCCESS,
  payload: response,
})

export const getFormBuilderPaymentReportsFailed = error => ({
  type: GET_FORM_BUILDER_PAYMENT_REPORTS_FAILED,
  payload: error,
})

export const getFormList = params => ({
  type: GET_FORM_LIST,
  payload: params,
})

export const getFormListSuccess = response => ({
  type: GET_FORM_LIST_SUCCESS,
  payload: response,
})

export const getFormListFailed = error => ({
  type: GET_FORM_LIST_FAILED,
  payload: error,
})

export const getFeatureClicks = params => ({
  type: GET_FEATURE_CLICKS,
  payload: params,
})

export const getFeatureClicksSuccess = response => ({
  type: GET_FEATURE_CLICKS_SUCCESS,
  payload: response,
})

export const getFeatureClicksFailed = error => ({
  type: GET_FEATURE_CLICKS_FAILED,
  payload: error,
})

export const resetFeatureClicks = () => ({
  type: RESET_FEATURE_CLICKS,
  payload: {},
})

export const getFeatureViewsByUser = params => ({
  type: GET_FEATURE_VIEWS_BY_USER,
  payload: params,
})

export const getFeatureViewsByUserSuccess = response => ({
  type: GET_FEATURE_VIEWS_BY_USER_SUCCESS,
  payload: response,
})

export const getFeatureViewsByUserFailed = error => ({
  type: GET_FEATURE_VIEWS_BY_USER_FAILED,
  payload: error,
})

export const resetFeatureViewsByUser = () => ({
  type: RESET_FEATURE_VIEWS_BY_USER,
  payload: {},
})

export const displayDefaultReports = params => ({
  type: DISPLAY_DEFAULT_REPORTS,
  payload: params,
})

export const displayDefaultReportsSuccess = response => ({
  type: DISPLAY_DEFAULT_REPORTS_SUCCESS,
  payload: response,
})

export const displayDefaultReportsFailed = error => ({
  type: DISPLAY_DEFAULT_REPORTS_FAILED,
  payload: error,
})

export const getAllFeatureReports = params => ({
  type: GET_ALL_FEATURE_REPORTS,
  payload: params,
})

export const getAllFeatureReportsSuccess = response => ({
  type: GET_ALL_FEATURE_REPORTS_SUCCESS,
  payload: response,
})

export const getAllFeatureReportsFailed = error => ({
  type: GET_ALL_FEATURE_REPORTS_FAILED,
  payload: error,
})
